/* src/app/forms/produtos/mercadolivre/meli-category-finder/meli-category-finder.component.scss */
.example-tree-progress-bar {
  margin-left: 30px;
}
.data-item-ul {
  text-decoration: underline;
  cursor: pointer;
  font-size: 80%;
}
.content {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 10px;
  border: 1px solid var(--tem-border);
  border-radius: 10px;
}
.title {
  font-weight: 400;
  font-size: 100%;
  margin-bottom: 20px;
  text-decoration: underline;
  cursor: pointer;
}
.subtitle {
  margin-bottom: 10px;
  border-bottom: solid;
  border-width: thin;
}
.left ul {
  font-size: 80%;
}
li {
  margin: 0 0 4px 0;
}
:host {
  display: flex;
  flex-direction: column;
  padding: 20px;
  height: 100%;
}
/*# sourceMappingURL=meli-category-finder.component.css.map */
